import apollo from 'graphql/apollo';
import { deleteDiscountMutation } from 'graphql/mutations';
import i18n from 'i18n';
import { find } from 'lodash';
import confirmModal from 'utils/confirmModal';
import { clientDelete } from 'utils/helpers';
import toast from 'utils/toast';
import isDiscountUsedInCart from './isDiscountUsedInCart';

const deleteDiscount = async ({ _id, categoryListQuery }) =>
  apollo.mutate({
    mutation: deleteDiscountMutation,
    variables: { _id },
    update: (cache) => {
      const cachedData = cache.readQuery({ query: categoryListQuery });
      const { categories } = cachedData;
      const category = categories.find(({ discounts }) => find(discounts, { _id }));
      if (!category) return;
      const newDiscounts = clientDelete({ array: category.discounts, _id });
      cache.writeQuery({
        query: categoryListQuery,
        data: {
          categories: cachedData.categories.map((c) =>
            find(c.discounts, { _id }) ? { ...c, discounts: newDiscounts } : c,
          ),
        },
      });
    },
  });
export const deleteDiscountWithConfirmation = ({ _id, categoryListQuery }) =>
  confirmModal({
    okText: i18n.t('admin.deleteDiscountConfirmation.ok'),
    cancelText: i18n.t('admin.deleteDiscountConfirmation.cancel'),
    okType: 'danger',
    onOk: async () => {
      const used = await isDiscountUsedInCart({ _id });
      const onConfirm = () => deleteDiscount({ _id, categoryListQuery }).then(toast.successDefault);
      if (!used) return onConfirm();
      return confirmModal({
        cancelText: i18n.t('admin.discountUsedInShoppingCartConfirmation.cancel'),
        okText: i18n.t('admin.discountUsedInShoppingCartConfirmation.ok'),
        okType: 'danger',
        onOk: onConfirm,
        title: i18n.t('admin.discountUsedInShoppingCartConfirmation.titleDelete'),
      });
    },
    title: i18n.t('admin.deleteDiscountConfirmation.title'),
  });
export default deleteDiscount;
